@if (component) {
<div class="wrap m-t-8 m-t-14-s p-t-1-s m-b-8">
    <!-- space / X, L -->
    @if (client.sizeId>1) {
    <div class="c-2"></div>
    }
    <div class="c-8 c-12-m c-12-s">
        <div class="center left-s">
            <div class="w-8 w-12-s">

                <!-- title -->
                <h2 class="h2"
                    *iCms="'title' of component"></h2>

                <!-- copy -->
                <p class="p1 m-t-3"
                   *iCms="'copy' of component"></p>
            </div>
        </div>

        <div class="m-t-8 m-t-12-s"
             [grid]="client.isS ? 1 : 2"
             [gridColumnGap]="client.isS ? 0 : 4">

            <!-- items - giftcard types -->
            @for (item of component.items; track $index) {
            <div>
                @if ($index === 0) {
                <href [link]="item.cta_link">
                    <ng-container *ngTemplateOutlet="giftCard; context: {$implicit: item}" />
                </href>
                } @else {
                <href [link]="item.cta_link + '#standardGiftCard=true'">
                    <ng-container *ngTemplateOutlet="giftCard; context: {$implicit: item}" />
                </href>
                }
            </div>
            }
        </div>

        <!-- balance checker -->
        <giftcards-balance-form [component]="component" />

        <!-- faq -->
        @if (!!component.faqs) {
        <div class="m-t-8 p-t-7-s">

            <!-- faq title -->
            <h3 class="h3 p-l m-b-3 m-b-5-s">{{'Gift card FAQs' | translate}}</h3>

            <!-- faq items -->
            <accordion>
                @for (faqItem of component.faqs; track $index) {
                <accordion-item [value]="`faq-${$index}`">
                    <ng-container ngProjectAs="[heading]">
                        <span *iCms="'question' of faqItem"></span>
                    </ng-container>
                    <div *iCms="'answer' of faqItem"></div>
                </accordion-item>
                }
            </accordion>
        </div>
        }
    </div>

    <ng-template #giftCard
                 let-item>
        <div class="m-t-2-s">
            <!-- img -->
            @if (item.image) {
            <img class="w-12 m-b-2 m-b-3-s"
                 [dfImage]="item.image"
                 [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                 [ratio]="1"
                 alt="">
            }
            <button class="button-inline has-icon"
                    type="button">
                <span *iCms="'cta_text' of item"></span>
            </button>
        </div>
    </ng-template>
</div>
}